import Offcanvas from 'react-bootstrap/Offcanvas';
import { useEffect, useState } from 'react';
import moment from 'moment';

function AdminEmailOffCanvas({ show, onClose, emailData }) {
    const [email, setEmail] = useState(null);

    useEffect(() => {
        if (show && emailData) {
            setEmail(emailData);
        }
    }, [show, emailData]);

    function handleClose() {
        onClose();
    }

    function getStatusColor(status) {
        if (!status) return '#6c757d'; // gris
        if (status === 'sent') return '#27ae60'; // verde
        if (status === 'pending') return '#f1c40f'; // amarillo
        if (status === 'error' || status === 'bounced') return '#e74c3c'; // rojo
        return '#3498db'; // azul claro para replied y otros
    }

    if (!email) return null;

    return (
        <Offcanvas
            backdrop={false}
            style={{ width: '500px', top: '55px' }}
            placement="end"
            show={show}
            onHide={onClose}
        >
            <Offcanvas.Header>
                <Offcanvas.Title className="d-flex justify-content-between w-100">
                    <button
                        onClick={handleClose}
                        className="btn btn-secondary btn-sm">Close</button>
                    <div className="bold fs-15">Email Details</div>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="sequence-detail-container">
                <div className="card bg-white card-shadow">
                    <div className="card-header bg-white">
                        <div className="bold">Email Info</div>
                    </div>
                    <div className="card-body fs-13">
                        <div className="mb-2"><b>From:</b> {email.user?.name} &lt;{email.user?.email}&gt;</div>
                        <div className="mb-2"><b>To:</b> {email.lead?.name} &lt;{email.lead?.email}&gt;</div>
                        <div className="mb-2"><b>Sequence:</b> {email.sequence?.name}</div>
                        <div className="mb-2"><b>Current Step:</b> {email.current_step}</div>
                        <hr />
                        {email.steps && email.steps.length > 0 && email.steps.map((step, idx) => (
                            <div key={idx} className="mb-4">
                                <div className="mb-1 bold">Step {idx + 1}</div>
                                <div className="mb-1"><b>Subject:</b> {step.sequence_step?.subject}</div>
                                <div className="mb-1"><b>Body:</b></div>
                                <div className="preview-step-div" style={{ minHeight: 80 }}>
                                    {step.sequence_step?.textBody}
                                </div>
                                <div className="mt-2 text-muted fs-12">
                                    <div><b>Status:</b> <span style={{ color: getStatusColor(step.status), fontWeight: 600 }}>{step.status}</span></div>
                                    <div><b>Sent at:</b> {step.email_log?.sent_at ? moment(step.email_log.sent_at).format('MM/DD/YYYY hh:mm a') : 'N/A'}</div>
                                </div>
                                {idx !== email.steps.length - 1 && <hr />}
                            </div>
                        ))}
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default AdminEmailOffCanvas; 